import React, { useEffect, useState } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context';
import Paymentorder from '../../Admin/components/Payment_order'
import Vieworder from '../../Admin/components/View_order'
import instance from '../../Utils/api'
import CircularProgress from '@mui/material/CircularProgress';
import Assignorder from '../components/Assign_order'
import Deadlineorder from '../components/Deadline_order';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Orderstatus from '../components/Order_status'
import DownloadExportData from '../../Utils/excel'
import Assigntailor from '../components/Assign_Tailor'
import Order_raise from '../components/order_raise'
import Orderinfo from '../components/Order_info'
import { Checkbox, FormControlLabel } from '@mui/material'


const Orders = () => {
  const role = localStorage.getItem('role');
  const url = window.location.pathname;
  const sortOptions = ['Last day', 'Last week', 'Last 15 days', 'Last 30 days', 'Last months']
  const title = { name: "Catalogue Orders", subheading: "Follow-up on catalogue orders", search: "Search orders", button: "Add order" }
  const statusOptions = ['None', 'New Order received', 'Estimate Sent', 'Estimate approved by Customer', 'Order In Progress', 'Order Ready', 'Delivery Scheduled', 'Order Delivered', 'Alteration request raised'];
  const paymentOptions = ['None', 'Paid', 'Pending', 'Partially Paid', 'Not Generated'];
  const tabsData = [
    {
      label: "All",
      name: "",
      options: ['Unassigned', 'Assigned', 'In Payment', 'In Progress', 'In Transit', 'Delivered', 'Completed', 'Canceled']
    },
    {
      label: "Assigned Orders",
      name: "Assigned",
      options: ['Assigned']
    },
    {
      label: "UnAssigned Orders",
      name: "Unassigned",
      options: ['Unassigned']
    },
  ]
  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Order Id", field: "order_id", },
    { label: "Name", field: "name", },
    // { label: "Location", field: "location",  },
    // { label: "Payment Status", field: "payment_status", },
    { label: "Order Status", field: "Orderstatus", },
    ...(role !== "SeniorDesigner"
      ? [{ label: "Assign", field: "Assignperson", }]
      : []
    ),
    { label: "Suborder", field: "SuborderCount", },
    // { label: "Deadline", field: "Deadline",  },
    { label: "Paid", field: "PaidAmount", },
    { label: "Pending", field: "PendingAmount", },
    { label: "Total", field: "TotalAmount", },
    { label: "Last Modified At", field: "Lastmodify", },
    // ...(url === '/admin/Reports/orders'
    //   ? []
    //   : [{ label: "Actions", field: "action",  }])
    // { label: "Assign Tailor", field: "Assigntailor",  },

    // { label: "Gender", field: "gender",  },
    // { label: "Fabric given", field: "fabricgiven",  },
    // { label: "size", field: "size",  },
    // { label: "Ordered Date", field: "ordereddate",  },
    // { label: "Delivered Date", field: "delivereddate",  },
    // { label: "Assigned Person", field: "assignedperson",  },
  ];
  //usestate define
  const { categoryId } = useParams();
  const { loading, setLoading } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const { deleteDialog, setdeleteDialog } = useGlobalContext();
  const { openConsultationDialog, setOpenConsultationDialog } = useGlobalContext();
  const [orders, setOrder] = useState([]);
  // const [assignDialog, setAssignDialog] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [getOrder, setgetOrder] = useState(false);
  const [raiseorder, setRaiseorder] = useState(false);
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [search, setSearch] = useState();
  const [status, setStatus] = useState(categoryId ? categoryId : "");
  const [paystatus, setPayStatus] = useState();
  const [tabSearch, setTabSearch] = useState();
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [download, setDownload] = useState(false);
  const [searchparams] = useSearchParams();
  const filter = searchparams.get('filtertype');
  const startDate = searchparams.get('startDate');
  const endDate = searchparams.get('endDate');
  const navigate = useNavigate();
  const [assigned, setAssigned] = useState(false);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseFilter = () => setAnchorEl(null);


  //order fetching
  const fetchorder = async (search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate, assigned) => {

    const params = {
      search,
      page: currentPage,
      ...(download ? { page: 1 } : { page: currentPage }),
      // ...(!download ? { limit: rowsperpage } : { limit: totalpages * rowsperpage }),
      ...(download
        ? { limit: totalpages * rowsperpage }
        : { limit: rowsperpage }
      ),
      // sortBy: "createdAt",
      // sortOrder: "desc",
      ...(filter && { range_by: filter, startDate: startDate, endDate: endDate }),
      ...(status && status !== 'None' ? { status } : {}),
      ...(paystatus && paystatus !== 'None' ? { payment_status: paystatus } : {}),
      ...(tabSearch ? { status: tabSearch } : {}),
      download,
      isorders: assigned
    };

    try {
      const response = await instance.get('/Order/Orders', { params });
      if (download) {
        DownloadExportData(response.data);
        setDownload(false);
        return;
      } else {
        const formatteddata = response?.data?.data?.map((order, index) => ({
          sno: index + 1,
          order_id: order?.order_id,
          order_Id: order?._id,
          name: order?.Customer?.name,
          location: order?.Customer?.location,
          Orderstatus: order?.status,
          payment_status: order?.payment_status,
          // Deadline: order?.deadline,
          Assignperson: order?.Admin?.name ? order?.Admin?.name : "Unassigned",
          SuborderCount: order?.sub_orders?.length,
          orderdata: order,
          PaidAmount: order?.paid_amount ? Number(order.paid_amount).toFixed(2) : "0.00",
          PendingAmount: order?.pending_amount ? Number(order.pending_amount).toFixed(2) : "0.00",
          TotalAmount: order?.total_amount ? Number(order.total_amount).toFixed(2) : "0.00",

          Lastmodify: order?.updatedAt
            ? new Date(order.createdAt).toLocaleDateString("en-GB")
            : "---",

          // Assigntailor: order?.assigned_tailor ? order?.assigned_tailor : "Unassigned",
          // gender: order?.Customer?.Gender, 
          // Status: order?.Customer?.status === true ? "Active" : "Inactive",
          // assign: order?.status,
          // fabricgiven: order?.fabric_given === true ? "Yes" : "No",
        }))
        setOrder(formatteddata)
        setTotalPages(response?.data?.totalPages);
        setCurrentPages(response?.data?.currentPage);
        setTotalcount(response?.data?.total);
      }
    }
    catch (error) {
      console.error('Error fetching orders:', error.message);
    } finally {
      setLoading(false);
    }
  }



  useEffect(() => {
    fetchorder(search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate, assigned);
    setLoading(true);
    setgetOrder(false)
  }, [getOrder, search, currentPage, rowsperpage, tabSearch, download, filter, startDate, endDate, assigned]);

  // const ordersDownload = async () => {
  //   try {
  //     setLoading(true); // Show loading indicator

  //     const response = await instance.get(`/Order/Orders?download=true&limit=${totalpages * rowsperpage}`, {
  //       responseType: 'blob', // Ensure response is treated as a binary file
  //     });
  //     console.log(response.data);

  //     DownloadExportData(response.data)
  //   } catch (error) {
  //     console.error('Error fetching orders:', error.message);
  //   } finally {
  //     setLoading(false); // Hide loading indicator
  //   }
  // };

  // // Handle Row Click for payment
  const handlePaymentClick = (order) => {
    setSelectedOrder(order.orderdata);
    setOpenDialog(true);
  };

  // Handle Row Click for view order
  const handleViewClick = (order) => {
    setSelectedOrder(order.orderdata);
    setopenviewDialog(true)
  }

  // Handle Row Click for assign order
  const handleAssignClick = (order) => {
    if (order.orderdata.status === 'Delivered' || order.orderdata.status === 'Canceled') {
      setstatusDialog(false)
    } else {
      setSelectedOrder(order.orderdata);
      setstatusDialog(true);
    }
  };
  // const handleAssigntailorClick = (order) => {
  //   setSelectedOrder(order.orderdata); 
  //   setAssignDialog(true); // Open the popup
  // };

  // Handle Row Click for set deadline order
  const handleDeadlinetimeClick = (order) => {
    if (order.orderdata.status === 'Delivered' || order.orderdata.status === 'Canceled') {
      setdeleteDialog(false)
    } else {
      setSelectedOrder(order.orderdata)
      setdeleteDialog(true)
    }
  }
  const handleraiseClick = (order) => {
    setSelectedOrder(order.orderdata)
    setRaiseorder(true)
  }

  // Handle Row Click for set order
  const handleOrderstatus = (order) => {
    if (order.orderdata.status === 'Canceled') {
      setOpenConsultationDialog(false)
    } else {
      setSelectedOrder(order.orderdata)
      setOpenConsultationDialog(true)
    }
  }

  const handleOrderClick = (order) => {
    navigate(`/admin/orderinfo/${order.order_Id}`);

  };

  const handleApplyFilter = () => {
    setCurrentPages(1);

    fetchorder(
      search,
      1,
      rowsperpage,
      tabSearch,
      false,
      filter,
      startDate,
      endDate,
      assigned
    );

    setAnchorEl(null);
  };


  const handleresetCloseFilter = () => {
    setPayStatus("");
    setStatus("");
    setTabSearch("");
    setSearch("");
    setAssigned(false);
    setCurrentPages(1);
    setgetOrder(true);
    handleCloseFilter();
  };



  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          files={true}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          showButton={false}
          setSearch={setSearch}
          Download={() => setDownload(true)}
        />
        {role === 'SeniorDesigner' &&
          <div className="admin-textfiled">
            <FormControlLabel
              control={
                <Checkbox
                  checked={assigned}
                  onChange={(e) => { setAssigned(e.target.checked) }}
                  color="primary"
                />
              }
              label=" Assigned Orders"
            />
          </div>}
        <SubHeader
          isAvailable={"orders"}
          // menu={true}
          // tabsData={tabsData}
          filter={true}
          isVisible={true}
          status={status}
          setStatus={setStatus}
          setPayStatus={setPayStatus}
          paystatus={paystatus}
          setTabSearch={setTabSearch}
          tabSearch={tabSearch}
          sortOptions={sortOptions}
          statusOptions={statusOptions}
          paymentOptions={paymentOptions}
          isOrderPage={true}
          onApplyFilter={handleApplyFilter}
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          handleCloseFilter={handleCloseFilter}
          handleClearFilter={handleresetCloseFilter}
        />
        {loading ? (
          <div className='loader-section'>
            <CircularProgress />
          </div>
        ) : (
          <CommonTable
            columns={columns}
            rows={orders}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            banner={false}
            orderinfo={true}
            payment={orders.Orderstatus === "Delivered" || orders.Orderstatus === "Canceled" ? false : true}
            deadline={orders.Orderstatus === "Delivered" || orders.Orderstatus === "Canceled" ? false : true}
            handlePaymentClick={handlePaymentClick}
            handleViewClick={handleViewClick}
            handleAssignClick={handleAssignClick}
            handleDeadlinetimeClick={handleDeadlinetimeClick}
            handleraiseClick={handleraiseClick}
            totalpages={totalpages}
            rowsperpage={rowsperpage}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPages={setCurrentPages}
            handleOrderstatus={handleOrderstatus}
            openConsultationDialog={openConsultationDialog}
            setOpenConsultationDialog={setOpenConsultationDialog}
            handleOrderClick={handleOrderClick}
          />
        )}
        <Vieworder
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}
          mode="orders"
        />
        <Paymentorder
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}
          mode="orders"
        />
        <Assignorder
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}
          mode="orders" // To differentiate the mode
        />
        <Order_raise
          assignDialog={raiseorder}
          setAssignDialog={setRaiseorder}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}

        />
        <Deadlineorder
          deleteDialog={deleteDialog}
          setdeleteDialog={setdeleteDialog}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}
          mode="orders" // To differentiate the mode
        />
        <Orderstatus
          openConsultationDialog={openConsultationDialog}
          setOpenConsultationDialog={setOpenConsultationDialog}
          selectedOrder={selectedOrder}
          setgetOrder={setgetOrder}
          mode="orders" // To differentiate the mode
        />

      </section>
    </>
  )

}
export default Orders;
